// TODO: NOT STAGING READY - have to put staging variant IDs

import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { buildStoreConfig } from '../storeAliasHelper';

export const CgmPatchesShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 799,
        variantId: '40728732565574',
        shopifyVariantId: 'gid://shopify/ProductVariant/40728732565574',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40728732565574:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 29,
        variantId: '40718030110780',
        shopifyVariantId: 'gid://shopify/ProductVariant/40718030110780',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40718030110780:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 29,
        variantId: '40200415477856',
        shopifyVariantId: 'gid://shopify/ProductVariant/40200415477856',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40200415477856:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 119,
        variantId: '44690781733106',
        shopifyVariantId: 'gid://shopify/ProductVariant/44690781733106',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/44690781733106:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 29,
        variantId: '49202716901694',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202716901694',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49202716901694:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 15,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 29,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 49,
        // CA inherits variant details from US
      },
      [ShopifyStore.MX]: {
        price: 502,
      },
      [ShopifyStore.SA]: {
        price: 129,
      },
      [ShopifyStore.ZA]: {
        price: 599,
      },
      [ShopifyStore.JP]: {
        price: 5400,
      },
    })
  : buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 799,
        variantId: '40728732565574',
        shopifyVariantId: 'gid://shopify/ProductVariant/40728732565574',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40728732565574:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 29,
        variantId: '40718030110780',
        shopifyVariantId: 'gid://shopify/ProductVariant/40718030110780',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40718030110780:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 29,
        variantId: '40200415477856',
        shopifyVariantId: 'gid://shopify/ProductVariant/40200415477856',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40200415477856:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 119,
        variantId: '44690781733106',
        shopifyVariantId: 'gid://shopify/ProductVariant/44690781733106',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/44690781733106:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 29,
        variantId: '49202716901694',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202716901694',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49202716901694:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 15,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 29,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 49,
        // CA inherits variant details from US
      },
      [ShopifyStore.MX]: {
        price: 502,
      },
      [ShopifyStore.SA]: {
        price: 129,
      },
      [ShopifyStore.ZA]: {
        price: 599,
      },
      [ShopifyStore.JP]: {
        price: 5400,
      },
    });
